module.exports = __webpack_public_path__ + "static/media/gears.4cb8ea57.svg";